import { add, differenceInDays, formatISO, isAfter, isBefore, isEqual, isValid, parse } from 'date-fns';
const unitMapping = {
  days: 'days',
  months: 'months'
};
const retrieveBaseDate = (config, today, arrival = undefined) => {
  if (config.start === 'today') {
    return today;
  }
  if (config.start === 'arrivalDate') {
    return arrival;
  }
  const startDate = parse(config.start, 'MM-dd', new Date());
  if (isValid(startDate)) {
    return startDate;
  }
};
export const calculateDate = (config, today, arrival = undefined) => {
  const base = retrieveBaseDate(config, today, arrival);
  if (!base) {
    return;
  }
  if (config.nextYear) {
    return add(base, {
      years: 1
    });
  }
  if (config.offset?.min) {
    const diff = differenceInDays(base, today);
    if (diff <= 7) {
      return add(base, {
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        [unitMapping[config.offset.unit]]: config.offset.count - diff
      });
    }
    return base;
  }
  return add(base, {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    [unitMapping[config.offset.unit]]: config.offset.count
  });
};
export const parseRangeEnd = (end, start) => {
  const parsed = parse(end, 'MM-dd', new Date());
  if (isBefore(parsed, start)) {
    return add(parsed, {
      years: 1
    });
  }
  return parsed;
};
export const getDefaultTravelPeriod = config => {
  const today = new Date();
  const node = config.period.find(({
    range
  }) => {
    const start = parse(range.start, 'MM-dd', new Date());
    const end = parseRangeEnd(range.end, start);
    if (isEqual(start, today)) {
      return true;
    }
    return isAfter(today, start) && isBefore(today, end);
  });
  if (!node) {
    return {
      start: '',
      end: ''
    };
  }
  const start = calculateDate(node.arrival, today);
  const end = calculateDate(node.return, today, start);
  if (start && end) {
    return {
      start: formatISO(start, {
        representation: 'date'
      }),
      end: formatISO(end, {
        representation: 'date'
      })
    };
  }
  return {
    start: '',
    end: ''
  };
};
export const getDefaultValues = config => {
  const defaultTravelPeriod = getDefaultTravelPeriod(config);
  return {
    startDate: defaultTravelPeriod.start,
    endDate: defaultTravelPeriod.end,
    duration: config.duration
  };
};